// To fixed filter

export default (value, number) => {
  let exponent = 2
  if (number) exponent = number
  return Math.round(value * (10 ** 2)) / (10 ** exponent)
}
